import styled from 'styled-components';

import { primitive } from 'styles/constants/primitives';

export const Container = styled.div`
  width: 100%;
`;

export const TitleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${primitive.$spacing3};
`;

export const Title = styled.span`
  font-family: ${Styles.fontFamily.body};
  font-weight: ${Styles.fontWeight.heavy};
  font-size: 1rem;
  color: ${primitive.th.$coffeeBrown};
`;

export const SubTitle = styled.span`
  font-family: ${Styles.fontFamily.body};
  font-weight: ${Styles.fontWeight.normal};
  font-size: 0.85rem;
  color: ${primitive.th.$coffeeBrown};
`;
